<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>Did easyJet admit liability?<Caret /></summary>
  <p>
    No, easyJet have not admitted liability. The settlement has been reached with no admission as to liability. This
    means that easyJet does not admit that it has acted unlawfully or in breach of duties in relation to the
    cyber-attack, but instead that it has decided to settle your Claim rather than continue to defend it further through
    the Courts.
  </p>
</details>
